import angular from 'angular';
import AgentDownloadLinkService from './agentDownloadLinkService.service';

let agentDownloadLinkServiceModule = angular.module('agentDownloadLinkService', []).service('agentDownloadLinkService', AgentDownloadLinkService);

export default agentDownloadLinkServiceModule;



// WEBPACK FOOTER //
// ./app/common/agentDownloadLinkService/agentDownloadLinkService.js